import { consoleRequest } from '@/console/api/http'
import { DevConsoleOrderPage, DevConsoleOrderTrace, OrderSearchParams, OrderTraceKey } from '@/console/api/types'

/**
 * LOGISPRD-13034 · 13035 — 개발자 콘솔 주문 조회 · Trace API(moms-be PR #3818, `@devOpsGate`).
 *
 * 응답은 `StandardResponse`(`{ meta, data }`) 라 여기서 `data` 를 벗긴다 — 실패는 axios 에러 그대로
 * 올려 `toPanelError` 가 401(권한) 과 400(`meta.message`) 을 가르게 둔다.
 *
 * 쿼리 인코딩 — `@/utils/request` 의 `Utils.qsStringify` 는 `encode: false` 다. 사람이 붙여넣은
 * 주문번호에 `&`·`#` 이 섞이면 쿼리가 쪼개져 엉뚱한 조건으로 조회되므로 문자열 값은 여기서 인코딩한다.
 * 배열(`orderStatuses`)은 qs 가 쉼표로 붙이고 Spring 이 `List` 로 받는다.
 */
const BASE = '/api/v1/dev-console/orders'

const text = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim()
  return trimmed ? encodeURIComponent(trimmed) : undefined
}

const compact = (query: Record<string, unknown>): UnknownMap =>
  Object.fromEntries(Object.entries(query).filter(([, v]) => v !== undefined && !(Array.isArray(v) && v.length === 0))) as UnknownMap

export const toOrderSearchQuery = (params: OrderSearchParams): UnknownMap =>
  compact({
    limit: params.limit,
    lastId: params.lastId,
    outboundCutSeqId: params.outboundCutSeqId,
    orderNumber: text(params.orderNumber),
    refNo1: text(params.refNo1),
    orderOptionNumber: text(params.orderOptionNumber),
    orderStatuses: params.orderStatuses,
    collectedDateFrom: params.collectedDateFrom,
    collectedDateTo: params.collectedDateTo,
  })

export const searchOrders = async (params: OrderSearchParams): Promise<DevConsoleOrderPage> => {
  const response = await consoleRequest.get<ApiResponseV2<DevConsoleOrderPage>, UnknownMap>(BASE, toOrderSearchQuery(params))
  return response.data
}

export const traceOrder = async (key: OrderTraceKey): Promise<DevConsoleOrderTrace> => {
  const response = await consoleRequest.get<ApiResponseV2<DevConsoleOrderTrace>, UnknownMap>(`${BASE}/trace`, {
    refNo1: text(key.refNo1),
    orderOptionNumber: text(key.orderOptionNumber),
  })
  return response.data
}
